import { defineStore } from 'pinia';
import { ref } from 'vue';

/** Store that used to trigger components' functions to prevent props drilling. */
export const useTriggerStore = defineStore('trigger', () => {
  // Use number to simplize trigger flow

  /** @type {import('vue').Ref<number> } */
  const registrationsChange = ref(0);
  const clearSelectedRowChange = ref(0);

  /** Trigger registrations change. */
  function triggerRegistrationsChange() {
    registrationsChange.value++;
  }

  /** Trigger to clear selected row in app-data-table-server */
  function triggerClearRow() {
    clearSelectedRowChange.value++;
  }

  return {
    // Variables
    registrationsChange,
    clearSelectedRowChange,

    // Functions
    triggerRegistrationsChange,
    triggerClearRow,
  };
});
